import { useRouteLoaderData } from "react-router-dom"
import AdminTeamsShow from "../../components/admin/AdminTeamsShow.jsx"
import { GetTeam } from "../../repo/TeamsRepo.js"

export default function TeamShowPage() {
  const response = useRouteLoaderData('admin-team')

  return(
    <section className="m-8">
      {response && (
        <AdminTeamsShow team={response}/>
      )}
    </section>
  )
}

export async function loader({ params, request }) {
  return await GetTeam(params.id)
}
